<div class="container">
  <div class="card">
    <div class="card-body text-center">
      <h1 class="card-title">Zahlung ist offen</h1>
      <p>Wir wartem auf Ihr Geld.</p>
    </div>
  </div>
</div>
